<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Otzi the Iceman was found in the Italian Alps in 1991. Today he had a measured
        <chemical-latex content="^{14}C" />
        decay rate of 8.00 disintegrations per minute per g of carbon (dpm/g C). How old is Otzi the
        Iceman if living organisms have a
        <chemical-latex content="^{14}C" />
        decay rate of
        <stemble-latex content="$15.3\,\text{dpm/g C?}$" />
        Note that the half-life of
        <chemical-latex content="^{14}C" />
        is 5715 years.
      </p>

      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\text{Age:}$"
        append-text="$\text{years}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemCPP1220S4Q6',
  components: {
    ChemicalLatex,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
};
</script>
